import { Link } from 'react-router-dom';

import { FOCO_VISIVEL } from 'utils/foco';

/** A experiência resgatada no ciclo, acima da lista, com o caminho para a página dela (TRC-06, TRC-21). */
export default function QuadroDaEscolha({ nome }: { nome: string }) {
  return (
    <section
      aria-labelledby="titulo-quadro-da-escolha"
      className="mb-6 flex flex-wrap items-center justify-between gap-4 rounded-xl bg-brand-white px-[22px] py-4 shadow-jj-01"
    >
      <div className="min-w-0">
        <h2 id="titulo-quadro-da-escolha" className="m-0 font-display text-[14px] font-bold text-brand-blue-dark">
          Sua escolha
        </h2>
        <p className="m-0 mt-1 text-[15px] font-bold leading-[1.5] text-content">{nome}</p>
      </div>
      <Link
        to="/catalogo-de-experiencias-list/feedback"
        className={`shrink-0 rounded-md bg-brand-yellow px-5 py-[11px] font-text text-[12px] font-bold uppercase tracking-[0.04em] text-brand-blue-dark no-underline transition-colors hover:bg-button-primary-hover hover:text-brand-blue-dark hover:no-underline ${FOCO_VISIVEL}`}
      >
        Ver minha experiência
      </Link>
    </section>
  );
}
